import { all } from '@redux-saga/core/effects';

import tunnelSaga from './tunnel';

export default function* rootSaga() {
    // all sagas that need to run simoultanously will be added here
    yield all([tunnelSaga()]);
}
